import { axios, def, handleError, handleResponse } from './internal';
import { storage } from '@goldblack/client-storage';

function AdminUserChangeBadge(userId, badges, onSuccess) {
    axios
        .post('/api/admin_user_changebadge', { userId, badges })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK: {
                    const { user } = res.data.data;
                    storage.transience.setState('internal.success', 'Badges updated.');
                    if (onSuccess) onSuccess(user);
                    break;
                }
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminUserChangeBadge };
